import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'comms_required';


const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = [];

const vFParams = {
  multiSelect: false,
  fieldTitle: 'Are comms required for this change?',
};

const commQuestion = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { commQuestion };
